import React, { Component } from 'react';
import { Col, Button, Form, FormGroup, Label, Input, FormText } from 'reactstrap';

class LoginForm extends Component {
  render() {
    return (
      <Form onSubmit={this.props.handleSubmit}>
        <FormGroup row>
          <Label for="email" sm={4}>Email Address</Label>
          <Col sm={8}>
            <Input required type="email" name="email" id="email" />
            <FormText color="muted">
              If you have never signed in on this device, <strong>an activation email will be sent to this address.</strong>
            Your email address is kept private and is not given to other members or any third party.
              Read our <a href="http://www.wreckfinder.co.uk/privacy-policy/" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
            </FormText>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col sm={{ size: 8, offset: 4 }}>
            <Button>Log in</Button>
            <FormText color="muted">
              By clicking Log in you are agreeing
              to our <a href="http://www.wreckfinder.co.uk/terms-conditions/" target="_blank" rel="noopener noreferrer">Terms Of Use</a>
            </FormText>
          </Col>
        </FormGroup>
      </Form>
    );
  }
}

export default LoginForm;



// WEBPACK FOOTER //
// ./src/components/login_form.js